(function() {
    'use strict';

    angular
        .module('editorApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        if (location.hash!= null && location.hash!= "") {
            var params = location.hash.split("/");
            if (params && params.length>1) {
                var storeId = params[1];
            }
        }else if(location.pathname!= null && location.pathname!= ""){
            var params = location.pathname.split("/");
            if (params && params.length>1) {
                var storeId = params[1];
            }
        }


        function getCookie (name) {
            if (document.cookie.length > 0) {
                var begin = document.cookie.indexOf(name + '=')
                if (begin !== -1) {
                    begin += name.length + 1 // cookie值的初始位置
                    var end = document.cookie.indexOf(';', begin) // 结束位置
                    if (end === -1) {
                        end = document.cookie.length // 没有;则end为字符串结束位置
                    }
                    return unescape(document.cookie.substring(begin, end))
                }
            }
            return null
        }

        if (storeId == null || storeId=="") {
            storeId = getCookie("store-id");
        }
        console.log("localStorageConfig.storeId:"+storeId);
        $localStorageProvider.setKeyPrefix('editor-'+ storeId+"-");
        $sessionStorageProvider.setKeyPrefix('editor-'+ storeId+"-");


    }
})();
